import { ROUTES, SCENARIOS } from "./constants";

/** Ruta actual -> ruta siguiente (donde lleva el botón Avanzar / flujo principal). */
const NEXT_ROUTE = {
	[ROUTES.SCENARIO1_INTRO]: ROUTES.SCENARIO1_CONVERSATION_INTRO,
	[ROUTES.SCENARIO1_CONVERSATION_INTRO]: ROUTES.SCENARIO1_CONVERSATION,
	[ROUTES.SCENARIO1_CONVERSATION]: ROUTES.SCENARIO1,
	[ROUTES.SCENARIO2_INTRO]: ROUTES.SCENARIO2,
	[ROUTES.SCENARIO3_INTRO]: ROUTES.SCENARIO3,
	[ROUTES.SCENARIO4_INTRO]: ROUTES.SCENARIO4,
	[ROUTES.SCENARIO5_INTRO]: ROUTES.SCENARIO5_CONVERSATION,
	[ROUTES.SCENARIO5_CONVERSATION]: ROUTES.SCENARIO5_EXPLANATION,
	[ROUTES.SCENARIO5_EXPLANATION]: ROUTES.SCENARIO5,
	[ROUTES.SCENARIO5_END]: ROUTES.SCENARIO5_PART2_INTRO,
	[ROUTES.SCENARIO5_PART2_INTRO]: ROUTES.SCENARIO5_PART2_INTRO2,
	[ROUTES.SCENARIO5_PART2_INTRO2]: ROUTES.SCENARIO5_PART2,
	[ROUTES.SCENARIO5_PART2]: ROUTES.SCENARIO5_PART2_QUESTION2,
	[ROUTES.SCENARIO6_INTRO]: ROUTES.SCENARIO6,
	[ROUTES.SCENARIO7_INTRO]: ROUTES.SCENARIO7,
	[ROUTES.SCENARIO7]: ROUTES.SCENARIO7_QUESTION2,
	[ROUTES.SCENARIO7_QUESTION2]: ROUTES.SCENARIO7_QUESTION3,
	[ROUTES.SCENARIO7_QUESTION3]: ROUTES.SCENARIO7_END,
	[ROUTES.SUPERTEST_INTRO]: ROUTES.SUPERTEST,
};

/** Rutas que al entrar cargan un quiz por escenario. Si la "siguiente" es una de estas, precargamos ese quiz. */
const QUIZ_PAGE_SCENARIO = {
	[ROUTES.SCENARIO1]: SCENARIOS.SCENARIO_1,
	[ROUTES.SCENARIO2]: SCENARIOS.SCENARIO_2,
	[ROUTES.SCENARIO3]: SCENARIOS.SCENARIO_3,
	[ROUTES.SCENARIO3_EXPLANATION]: SCENARIOS.SCENARIO_3,
	[ROUTES.SCENARIO5]: SCENARIOS.SCENARIO_5,
	[ROUTES.SCENARIO5_PART2]: SCENARIOS.SCENARIO_5,
	[ROUTES.SCENARIO5_PART2_QUESTION2]: SCENARIOS.SCENARIO_5,
	[ROUTES.SCENARIO6]: SCENARIOS.SCENARIO_6,
	[ROUTES.SCENARIO7]: SCENARIOS.SCENARIO_7,
	[ROUTES.SCENARIO7_QUESTION2]: SCENARIOS.SCENARIO_7,
	[ROUTES.SCENARIO7_QUESTION3]: SCENARIOS.SCENARIO_7,
	[ROUTES.SUPERTEST]: SCENARIOS.SUPERTEST,
};

/** Índice del quiz en la lista del escenario para cada ruta de quiz (escenarios con varias preguntas). */
const QUIZ_PAGE_INDEX = {
	[ROUTES.SCENARIO5]: 0,
	[ROUTES.SCENARIO5_PART2]: 1,
	[ROUTES.SCENARIO5_PART2_QUESTION2]: 2,
	[ROUTES.SCENARIO7]: 0,
	[ROUTES.SCENARIO7_QUESTION2]: 1,
	[ROUTES.SCENARIO7_QUESTION3]: 2,
};

export function getNextRoute(pathname) {
	if (!pathname || typeof pathname !== "string") return null;
	const normalized = pathname.replace(/\/$/, "") || "/";
	return NEXT_ROUTE[normalized] ?? null;
}

export function getScenarioIdForQuizPage(pathname) {
	if (!pathname || typeof pathname !== "string") return null;
	const normalized = pathname.replace(/\/$/, "") || "/";
	return QUIZ_PAGE_SCENARIO[normalized] ?? null;
}

/** Índice del quiz (0, 1, 2...) para esa ruta. Si no está definido, la página usa el primer quiz (0). */
export function getQuizIndexForQuizPage(pathname) {
	if (!pathname || typeof pathname !== "string") return 0;
	const normalized = pathname.replace(/\/$/, "") || "/";
	return QUIZ_PAGE_INDEX[normalized] ?? 0;
}
